import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

export const headNeck: ModelConfigParams = {
  bodyParts: [
    'artery',
    'bone',
    'musclePterygoid',
    'muscleStyloglossus',
    'muscleStylohyoid',
    'muscleStylopharyngeus',
    'muscleTongue',
    'tumour',
  ],
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [-40, 1560],
  internal: true,
}
